import APIConnection from '@/API/APIConnection';
export default {
    stats(){
        return APIConnection.get('admin/stats');
    },

    pageViews(){
        return APIConnection.get('admin/pageViews');
    }
}